import React from "react";
import {Button} from "../../button/Button";
import { useTranslation } from "react-i18next";

export const TaskHeaderEdit = ({ header, setHeader, handleSave }) => {
    const { t } = useTranslation();
    return (
        <form
            onSubmit={handleSave}
            className={'todo-header-container'}
        >
            <input
                placeholder={t('taskHeader.enterListName')}
                type="text"
                value={header}
                onChange={(e) => setHeader(e.target.value)}
            />
            <Button onClick={handleSave} text={t('task.save')} type="primary"/>
        </form>
    );
};